<template>
  <el-input
    @input="latlngChange"
    v-model="latlng"
    size="default"
    placeholder="纬经度"
    @mousedown.stop
  ></el-input>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message, debounceA } from '@/utils/js/initVariable';

// props
const props = defineProps({
  change: { type: Function, default: (val)=>{ console.log(val); }, },
  defaultVal: { type: String, },
});
// emit
const emit = defineEmits([
  
]);

const latlng = ref(props.defaultVal),
latlngChange = debounceA((val)=>{
  checkLatLng(val, props.change);
}, 0.5 * 1000);

const changeLatLngVal = (val)=>{
  latlng.value = val;
}

const checkLatLng = (value, callback) => {
  const parts = value.trim().replaceAll('，', ',').split(',');
  if (parts.length !== 2) {
    message('请输入正确的经纬度格式，用逗号分隔', 2);
    return;
  }
  const lng = parts[1];
  const lat = parts[0];
  
  // 验证经度
  // const lngRegex = /^-?(?:180(?:\.0{1,6})?|(?:[1-9]?\d(?:\.\d{1,6})?))$/;
  const lngRegex = /^[-+]?([1-9]?[0-9]|1[0-7][0-9]|180)(\.\d+)?$/;
  
  if (!lngRegex.test(lng)) {
    message('经度范围为-180到180', 2);
    return;
  }
  
  // 验证纬度
  const latRegex = /^[-+]?([1-8]?[0-9]|90)(\.\d+)?$/;
  if (!latRegex.test(lat)) {
    message('纬度范围为-90到90', 2);
    return;
  }
  
  callback({
    lat,
    lng,
  });
}

defineExpose({
  changeLatLngVal,
})

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>